import MaterialBox from "../../../../../__snowpack__/pkg/@mui/material/Box.js";
import MaterialTypography from "../../../../../__snowpack__/pkg/@mui/material/Typography.js";
import React from "react";
import Icon from "../../../atoms/icon/icon.component.js";
import Tooltip from "../../../atoms/tooltip/tooltip.component.js";
import {BoxContainer, OptionsContainer, SelectOptionsContainer} from "./select-options.styles.js";
function TableSelectOptions({
  hidden,
  rowSelectOptions,
  selectedRows = [],
  type
}) {
  if (hidden) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(OptionsContainer, null, /* @__PURE__ */ React.createElement(BoxContainer, null, /* @__PURE__ */ React.createElement(MaterialTypography, null, type)), /* @__PURE__ */ React.createElement(SelectOptionsContainer, null, rowSelectOptions && rowSelectOptions.map((option, index) => {
    if (option.hidden) {
      return null;
    }
    return /* @__PURE__ */ React.createElement(Tooltip, {
      key: index,
      title: option.tooltip,
      placement: "bottom",
      enterDelay: 0,
      leaveDelay: 0
    }, /* @__PURE__ */ React.createElement(MaterialBox, {
      onClick: () => option.onClick(selectedRows)
    }, /* @__PURE__ */ React.createElement(Icon, {
      color: "secondary",
      size: "medium"
    }, option.icon)));
  })));
}
export default TableSelectOptions;
